<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="630"
      overlay-color="grey-500"
    >
      <v-card class="text-center">
        <v-toolbar class="px-4" color="transparent" flat height="48">
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" class="pt-7 mr-4" justify="center">
              <v-btn @click="dialog=false" icon small><v-icon size="20" color="grey-500">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pb-7">
          <v-img contain :height="100" :src="require(`@/assets/alert-dialog/ax.svg`)" />
          <span class="d-block title mt-4 font-weight-bold green-500--text">SII informa - Suspensión Temporal de Boleta Electrónica</span>
          <v-col class="text-left subtitle-2 pb-0">
            Le informamos que el Servicio de Impuestos Internos (SII) realizará una suspensión total del sistema de <strong>Boleta Electrónica</strong> hoy <strong>miércoles 22 de octubre de 2025</strong>, desde las <strong>20:00 horas</strong>, con una duración máxima de <strong>4 horas</strong>.

            Durante este período no estarán disponibles los siguientes servicios:

            <ul class="pl-6 mt-3">
              <li>Recepción y validación de boletas.</li>
              <li>Consulta de validez de boletas.</li>
              <li>API de consulta y envío de boletas.</li>
            </ul>

            <span class="d-block mt-3">Esto no impactará su operación, podrá seguir generando ventas.</span>

            <span class="d-block mt-3">Nuestros sistemas están preparados para realizar la contención necesaria y enviar al SII todos los documentos al momento de ser activados sus servicios.</span>

            <!-- <span class="d-block mt-4">
              Para más información: <a class="text-decoration-none" href="https://www.sunat.gob.pe/mensajes/octubre/2025/aviso-ti-061025.html" target="_blank">Consulta aquí</a>
            </span> -->
            <span class="mt-3 d-block">Atentamente Equipo Soporte</span>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    data () {
    return {
      dialog: false
    }
  },
  created () {
    this.dialog = true
  }
}
</script>
